import React, { useEffect, useState } from "react";
import { Box, Chip } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { isString } from "lodash";
import toastError from "../../errors/toastError";
import api from "../../services/api";

// Motivo do atendimento usa um catalogo proprio de tags (kanban = 2),
// separado das tags gerais do topo da mensagem (kanban = 0) e das
// etapas do Kanban (kanban = 1), pra nao misturar os tres usos.
const MOTIVO_KANBAN_VALUE = 2;

const getRandomHexColor = () => {
    const red = Math.floor(Math.random() * 200);
    const green = Math.floor(Math.random() * 200);
    const blue = Math.floor(Math.random() * 200);
    return `#${red.toString(16).padStart(2, '0')}${green.toString(16).padStart(2, '0')}${blue.toString(16).padStart(2, '0')}`;
};

export function MotivoAtendimentoSelect({ ticket }) {
    const [tags, setTags] = useState([]);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        let isMounted = true;
        loadTags(isMounted).then(() => {
            const currentReasonTag = (ticket.tags || []).find(tag => tag.kanban === MOTIVO_KANBAN_VALUE);
            setSelected(currentReasonTag || null);
        });

        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ticket.tags, ticket.queueId]);

    const loadTags = async (isMounted) => {
        try {
            const { data } = await api.get(`/tags/list`, {
                params: { kanban: MOTIVO_KANBAN_VALUE, queueId: ticket.queueId || undefined }
            });
            if (isMounted) {
                setTags(data);
            }
        } catch (err) {
            toastError(err);
        }
    };

    const createTag = async (name) => {
        try {
            // Motivo criado direto na conversa ja nasce vinculado a fila
            // atual - evita ele aparecer depois pra quem atende outra fila
            // (ex: um motivo tecnico aparecendo pro financeiro).
            const { data } = await api.post(`/tags`, {
                name,
                kanban: MOTIVO_KANBAN_VALUE,
                color: getRandomHexColor(),
                queueId: ticket.queueId || null
            });
            return data;
        } catch (err) {
            toastError(err);
            return null;
        }
    };

    const applyTagToTicket = async (tag) => {
        try {
            const hasReasonTag = (ticket.tags || []).some(t => t.kanban === MOTIVO_KANBAN_VALUE);
            if (hasReasonTag) {
                await api.delete(`/ticket-tags/${ticket.id}/reason`);
            }
            if (tag) {
                await api.put(`/ticket-tags/${ticket.id}/${tag.id}`);
            }
            setSelected(tag);
        } catch (err) {
            toastError(err);
        }
    };

    const onChange = async (e, value, reason) => {
        if (reason === "create-option" && isString(value)) {
            if (value.trim().length < 3) {
                toastError("Motivo muito curto!");
                return;
            }
            const newTag = await createTag(value.trim());
            if (newTag) {
                await loadTags(true);
                await applyTagToTicket(newTag);
            }
            return;
        }

        if (value && typeof value === "object") {
            await applyTagToTicket(value);
        } else {
            await applyTagToTicket(null);
        }
    };

    return (
        <Box>
            <Autocomplete
                size="small"
                options={tags}
                value={selected}
                freeSolo
                clearOnBlur
                selectOnFocus
                handleHomeEndKeys
                onChange={onChange}
                getOptionLabel={(option) => (isString(option) ? option : option.name || "")}
                renderOption={(option) => option.name}
                renderInput={(params) => (
                    <TextField {...params} variant="outlined" label="Motivo do atendimento" placeholder="Ex: Problema de impressora" />
                )}
            />
            {selected && (
                <Chip
                    size="small"
                    label={selected.name}
                    onDelete={() => applyTagToTicket(null)}
                    style={{ backgroundColor: selected.color, color: "#FFF", fontWeight: "bold", marginTop: 4 }}
                />
            )}
        </Box>
    );
}
